import { Button, Header, Modal } from 'semantic-ui-react';

import { useAppContext } from '../Contexts/AppContext';

export default function Disclaimer() {
    const { Reducer, Actions } = useAppContext();

    function onCloseClick() {
        Actions.setDisclaimer(false);
    }

    return (
        <Modal open={Reducer.isDisclaimerOpen}>
            <Modal.Header>
                JVCKENWOOD USA CORPORATION<br />
                Extended Services Portal
            </Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Header>Terms of Service</Header>
                    <p>
                        By printing a label and shipping the returned product(s), you agree and acknowledge that JVCKENWOOD USA Corporation ("JKUSA") shall not be held responsible for any loss, damage and/or injury caused by, during and for the time period to and through delivery of the return shipment of such product(s). Further, you shall indemnify and hold JKUSA harmless for any act or omission by you, your company, its affiliates, employees or agents related to the same. All terms and conditions of JKUSA's applicable warranty statement remain in full force and effect.
                    </p>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                {Reducer.userInformation.FirstLogin
                    ? <Button content='Confirmed' icon='check' color='blue' onClick={onCloseClick} />
                    : <Button content="Close" onClick={onCloseClick} />}
            </Modal.Actions>
        </Modal>
    );
}
